import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { UiService } from '../../../services/core.ui.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { UserService } from '../../../services/core.user.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'reset-password-view',
  template: require('./resetpassword.component.html')
})
export class ResetPasswordViewComponent implements OnInit {
  @Input() passwordRulesDesc: any;

  password: string = '';
  confirmPassword: string = '';
  unixName: string;
  confirmationHash: string;
  changingPassword: boolean = false;
  missingPassword: boolean = false;
  mismatchedPasswords: boolean = false;

  constructor(
    private uiService: UiService,
    private translateService: GfTranslateService,
    private userService: UserService,
    private stateService: StateService, 
    
  ) {}

  ngOnInit() {
    this.uiService.setFocus('resetPassword');

    this.unixName = this.stateService.params?.unixName;
    this.confirmationHash = this.stateService.params?.confirmationHash;

    if (!this.unixName?.length || !this.confirmationHash?.length) {
      this.uiService.message.showWarning(
        this.translateService.translate('Sorry, the username or confirmation code was missing or incorrect'),
        this.translateService.translate('Reset Password')
      );
      this.stateService.go('home.user.login');
      return;
    }
  }

  resetPassword() {
    if (!this.validateForm()) {
      this.uiService.message.showWarning(
        this.translateService.translate('Your new password and the password confirmation must match and must comply with the required format.'),
        this.translateService.translate('Warning')
      );
      return;
    }

    this.changingPassword = true;
    this.userService.changePassword(this.unixName, this.confirmationHash, this.password)
      .then(() => {
        this.uiService.message.showSuccess(
          this.translateService.translate('Your password has been successfully reset.  Please log in to complete the process.'),
          this.translateService.translate('Success')
        );
        this.stateService.go('home.user.login');
      })
      .catch((response: any) => {
        console.log(response);
        let msg = this.translateService.translate('Password reset failed');
        if (!_.isEmpty(_.find(_.get(response, 'data.password', []), { type: 'regex' }))) {
          msg += '. ' + this.translateService.translate('The password you entered does not comply with the required format.');
        }
        this.uiService.message.showError(msg, this.translateService.translate('Error'));
      })
      .finally(() => {
        this.changingPassword = false;
      });
  }

  private validateForm(): boolean {
    this.missingPassword = !this.password?.length;
    this.mismatchedPasswords = false;

    if (!this.missingPassword) {
      this.mismatchedPasswords = (this.password !== this.confirmPassword);
    }

    return (!this.missingPassword && !this.mismatchedPasswords);
  }
}